export const FETCH_STATUS = {
	inProgress: 'IN_PROGRESS_FETCH_STATUS',
	error: 'ERROR_FETCH_STATUS',
	forbiddenError: 'ERROR_FORBIDDEN_FETCH_STATUS',
} as const;
